let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("k1G7Z")).then(() => parcelRequire('3UFPf'));